export const getDoctorList = (store) => store.doctor.data;
export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.doctor;
  return rest;
};
